import { http, HttpResponse } from 'msw'

import { allDiagnostics } from 'app/mocks/data/machines/diagnostics'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

export const getAllDiagnostics = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.DIAGNOSTIC}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const machineIdsFilter = searchParams.get('machine__id__in')

        let allDiagnosticsFiltered = allDiagnostics

        // Machine filter
        if (machineIdsFilter) {
            const machineIdsSplit = machineIdsFilter.split(',')

            allDiagnosticsFiltered = allDiagnosticsFiltered.filter(
                (diagnostic) =>
                    machineIdsSplit.includes(diagnostic.machine.id.toString()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allDiagnosticsFiltered.length > limit
                ? offset + limit
                : allDiagnosticsFiltered.length

        const results = allDiagnosticsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allDiagnosticsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json({
            count: allDiagnosticsFiltered.length,
            next,
            results,
        })
    },
)
